import React from 'react';
import { useLocation } from 'react-router-dom';
import FloatingSelfRegisterForm from './FloatingSelfRegisterForm';

const ConditionalFloatingForm = () => {
  const location = useLocation();
  const homeNavRoutes = ['/', '/whoweare', '/contactus', '/gallery'];

  if (homeNavRoutes.includes(location.pathname)) {
    return <FloatingSelfRegisterForm />;
  }

  return null;
};

export default ConditionalFloatingForm;
